export const COMPLIANCE_OPTIONS: string[] = [
  'HIPAA',
  'PCI',
  'CMMC/NIST 800-171',
  'PII',
  'Company Critical Proprietary High-Value Data'
];

export default COMPLIANCE_OPTIONS;
